export default __webpack_public_path__ + "static/media/grayPlus.e534cb53.svg";